import type {
    BasicDetailsPagePropertyOnboardingContextFieldsV2,
    BasicDetailsPagePropertyOnboardingContextIdsV2,
} from "@agoda/analytics-messages-definition-property-onboarding/contexts.split";
import {
    BasicDetailsPagePropertyOnboardingContextManifestV2,
    WebListYourPropertyBasicDetailsVisitEventPropertyOnboardingManifestV1,
} from "@agoda/analytics-messages-definition-property-onboarding/manifest/basic-details-page";
import {
    AddBedroomElementPropertyOnboardingManifestV1,
    BedroomAddBedTypeElementPropertyOnboardingManifestV1,
    BedroomBedTypeDropdownElementPropertyOnboardingManifestV1,
    BedroomDecreaseBedElementPropertyOnboardingManifestV1,
    BedroomDeleteBedTypeElementPropertyOnboardingManifestV1,
    BedroomIncreaseBedElementPropertyOnboardingManifestV1,
    CommonSpaceAddBedTypeElementPropertyOnboardingManifestV1,
    CommonSpaceBedTypeDropdownElementPropertyOnboardingManifestV1,
    CommonSpaceDecreaseBedElementPropertyOnboardingManifestV1,
    CommonSpaceDeleteBedTypeElementPropertyOnboardingManifestV1,
    CommonSpaceIncreaseBedElementPropertyOnboardingManifestV1,
    CommonSpaceToggleElementPropertyOnboardingManifestV1,
    ConfirmDeleteBedroomElementPropertyOnboardingManifestV1,
    DecreaseBathroomsElementPropertyOnboardingManifestV1,
    DecreaseMaxGuestsAllowedElementPropertyOnboardingManifestV1,
    IncreaseBathroomsElementPropertyOnboardingManifestV1,
    IncreaseMaxGuestsAllowedElementPropertyOnboardingManifestV1,
    ListYourPropertyBackElementPropertyOnboardingManifestV1,
    ListYourPropertyNextElementPropertyOnboardingManifestV1,
    ListYourPropertyStepperElementPropertyOnboardingManifestV1,
    PropertySizeElementPropertyOnboardingManifestV1,
    RemoveBedroomElementPropertyOnboardingManifestV1,
    SaveAndExitElementPropertyOnboardingManifestV1,
} from "@agoda/analytics-messages-definition-property-onboarding/manifest/elements";
import { BaseContextFieldsMapping, GetAttributeSafe } from "../../functions/appContext";
import { defineBinder } from "../../functions/defineBinder";

export const basicDetailsBinder = defineBinder(({ webAnalytics, action: { click } }) => {
    webAnalytics.pageContext<
        BasicDetailsPagePropertyOnboardingContextIdsV2,
        BasicDetailsPagePropertyOnboardingContextFieldsV2
    >(BasicDetailsPagePropertyOnboardingContextManifestV2.ids, {
        auth_user_id: BaseContextFieldsMapping.auth_user_id,
        member_id: BaseContextFieldsMapping.member_id,
        property_id: BaseContextFieldsMapping.property_id,
        onboarding_id: BaseContextFieldsMapping.onboarding_id,
        is_internal_user: BaseContextFieldsMapping.is_internal_user,
    });

    webAnalytics.observe(WebListYourPropertyBasicDetailsVisitEventPropertyOnboardingManifestV1.ids, {});

    webAnalytics.observeElement([click], ListYourPropertyNextElementPropertyOnboardingManifestV1.ids, {});
    webAnalytics.observeElement([click], ListYourPropertyBackElementPropertyOnboardingManifestV1.ids, {});
    webAnalytics.observeElement([click], ListYourPropertyStepperElementPropertyOnboardingManifestV1.ids, {
        action_element_value: (element: HTMLElement) => GetAttributeSafe(element, "step-name"),
    });
    webAnalytics.observeElement([click], SaveAndExitElementPropertyOnboardingManifestV1.ids, {});

    webAnalytics.observeElement([click], BedroomBedTypeDropdownElementPropertyOnboardingManifestV1.ids, {
        action_element_value: (element: HTMLElement) => GetAttributeSafe(element, "bed-type-name"),
    });
    webAnalytics.observeElement([click], BedroomIncreaseBedElementPropertyOnboardingManifestV1.ids, {});
    webAnalytics.observeElement([click], BedroomDecreaseBedElementPropertyOnboardingManifestV1.ids, {});
    webAnalytics.observeElement([click], BedroomAddBedTypeElementPropertyOnboardingManifestV1.ids, {});
    webAnalytics.observeElement([click], BedroomDeleteBedTypeElementPropertyOnboardingManifestV1.ids, {});
    webAnalytics.observeElement([click], AddBedroomElementPropertyOnboardingManifestV1.ids, {});
    webAnalytics.observeElement([click], RemoveBedroomElementPropertyOnboardingManifestV1.ids, {});
    webAnalytics.observeElement([click], ConfirmDeleteBedroomElementPropertyOnboardingManifestV1.ids, {});
    webAnalytics.observeElement([click], CommonSpaceToggleElementPropertyOnboardingManifestV1.ids, {});
    webAnalytics.observeElement([click], CommonSpaceBedTypeDropdownElementPropertyOnboardingManifestV1.ids, {
        action_element_value: (element: HTMLElement) => GetAttributeSafe(element, "bed-type-name"),
    });
    webAnalytics.observeElement([click], CommonSpaceIncreaseBedElementPropertyOnboardingManifestV1.ids, {});
    webAnalytics.observeElement([click], CommonSpaceDecreaseBedElementPropertyOnboardingManifestV1.ids, {});
    webAnalytics.observeElement([click], CommonSpaceAddBedTypeElementPropertyOnboardingManifestV1.ids, {});
    webAnalytics.observeElement([click], CommonSpaceDeleteBedTypeElementPropertyOnboardingManifestV1.ids, {});
    webAnalytics.observeElement([click], IncreaseBathroomsElementPropertyOnboardingManifestV1.ids, {});
    webAnalytics.observeElement([click], DecreaseBathroomsElementPropertyOnboardingManifestV1.ids, {});
    webAnalytics.observeElement([click], IncreaseMaxGuestsAllowedElementPropertyOnboardingManifestV1.ids, {});
    webAnalytics.observeElement([click], DecreaseMaxGuestsAllowedElementPropertyOnboardingManifestV1.ids, {});
    webAnalytics.observeElement([click], PropertySizeElementPropertyOnboardingManifestV1.ids, {});
});
